// Config values 
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 15;
export const RES_PER_PAGE = 10;
export const START_PAGE = 1;
export const KEY = '7ee49ccd-f00f-46db-92af-24d348138483';
export const MODAL_TIMEOUT = 2.5; 
